import React from 'react';
import { useIsDesktopDimension } from '@beef/ui-kit';
import { Mobile } from "./components/Mobile";
import { Desktop } from "./components/Desktop";
import { MenuModalLayoutRC, ShopMenuModalLayoutRC } from "./connected";
export var MenuModalRC = function MenuModalRC() {
  var isDesktop = useIsDesktopDimension();
  return /*#__PURE__*/React.createElement(MenuModalLayoutRC, {
    "data-t-id": "components-MenuModal"
  }, isDesktop ? /*#__PURE__*/React.createElement(Desktop, null) : /*#__PURE__*/React.createElement(Mobile, null));
};
export var ShopMenuModalRC = function ShopMenuModalRC() {
  return /*#__PURE__*/React.createElement(ShopMenuModalLayoutRC, null, /*#__PURE__*/React.createElement(Mobile, {
    "data-t-id": "components-MenuModal"
  }));
};